<div class="response-projects-list">
  <div class="response-projects-list-header">
    <div class="response-projects-list-title-row">
      <h1 class="response-projects-list-title">{{ 'tenders.responses.title' | translate }}</h1>
      @if (creditsAllowed !== null) {
        <div
          class="response-projects-list-credits-wrapper"
          (mouseenter)="creditPopoverOpen = true"
          (mouseleave)="creditPopoverOpen = false"
        >
          <span class="response-projects-list-credits-badge" [class.response-projects-list-credits-badge--empty]="isQuotaReached">
            {{ creditsLeft }} crédit{{ creditsLeft > 1 ? 's' : '' }}
          </span>
          @if (creditPopoverOpen) {
            <div class="response-projects-list-credits-popover">
              <div class="response-projects-list-credits-popover-inner">
                <div class="response-projects-list-credits-popover-header">
                  <span class="response-projects-list-credits-popover-title">{{
                    'tenders.responses.credits-popover.title' | translate
                  }}</span>
                  <span
                    class="response-projects-list-credits-popover-count"
                    [class.response-projects-list-credits-popover-count--empty]="isQuotaReached"
                    >{{ creditsUsed }}/{{ creditsAllowed }}</span
                  >
                </div>
                <div class="response-projects-list-credits-popover-breakdown">
                  <div class="response-projects-list-credits-popover-row">
                    <span>{{ 'tenders.responses.credits-popover.active' | translate }}</span>
                    <span>{{ activeProjects.length }}</span>
                  </div>
                  <div class="response-projects-list-credits-popover-row">
                    <span>{{ 'tenders.responses.credits-popover.closed' | translate }}</span>
                    <span>{{ closedProjects.length }}</span>
                  </div>
                  <div class="response-projects-list-credits-popover-row response-projects-list-credits-popover-row--last">
                    <span>{{ 'tenders.responses.credits-popover.deleted' | translate }}</span>
                    <span>{{ deletedCount }}</span>
                  </div>
                </div>
                @if (expirationDate) {
                  <div class="response-projects-list-credits-popover-date">
                    <i class="ph ph-calendar-blank" aria-hidden="true"></i>
                    <span>{{ 'tenders.responses.credits-popover.until' | translate: { date: expirationDate } }}</span>
                  </div>
                }
                <a class="response-projects-list-credits-popover-cta" [href]="mailtoHref" target="_blank">
                  <i class="ph ph-envelope" aria-hidden="true"></i>
                  {{ 'tenders.responses.credits-popover.cta' | translate }}
                </a>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <button
      type="button"
      class="response-projects-list-create-btn"
      [class.response-projects-list-create-btn--blocked]="isBlocked"
      (click)="createProject()"
    >
      <i class="ph ph-plus" aria-hidden="true"></i>
      {{ 'tenders.responses.new-response' | translate }}
    </button>
  </div>

  <!-- Search bar-->
  <div class="response-projects-list-search">
    <div class="response-projects-list-search-inner">
      <i class="ph ph-magnifying-glass response-projects-list-search-icon"></i>
      <input
        class="response-projects-list-search-input"
        type="text"
        [(ngModel)]="searchQuery"
        [placeholder]="'tenders.responses.search-placeholder' | translate"
        autocomplete="off"
      />
      @if (isSearching) {
        <button type="button" class="response-projects-list-search-clear" (click)="searchQuery = ''" aria-label="Effacer la recherche">
          <i class="ph ph-x"></i>
        </button>
      }
    </div>
  </div>

  <div class="response-projects-list-scroll">
    <!-- Section Actifs -->
    <button type="button" class="response-projects-list-section-toggle" (click)="activeOpen = !activeOpen">
      <span class="response-projects-list-section-badge">{{ filteredActiveProjects.length + (newProjectPlaceholder ? 1 : 0) }}</span>
      <span class="response-projects-list-section-label">{{ 'tenders.responses.section-active' | translate }}</span>
      <span class="response-projects-list-section-line"></span>
      <i
        class="ph ph-caret-down response-projects-list-section-caret"
        [class.response-projects-list-section-caret--open]="activeOpen"
        aria-hidden="true"
      ></i>
    </button>
    <div class="response-projects-list-section-body" [class.response-projects-list-section-body--open]="activeOpen">
      @if (newProjectPlaceholder) {
        <button
          type="button"
          class="response-projects-list-item response-projects-list-item--new"
          [class.response-projects-list-item-active]="newProjectPlaceholder.id === activeProjectId"
          (click)="onProjectSelect(newProjectPlaceholder.id)"
        >
          <span class="response-projects-list-item-label">{{ newProjectPlaceholder.name }}</span>
        </button>
      }
      @for (project of filteredActiveProjects; track project.id) {
        <button
          type="button"
          class="response-projects-list-item"
          [class.response-projects-list-item-active]="project.id === activeProjectId"
          (click)="onProjectSelect(project.id)"
        >
          <span
            class="response-projects-list-item-label"
            [ngbTooltip]="project.name"
            placement="right"
            tooltipClass="response-project-view-title-tooltip"
            overflowTooltip
            >{{ project.name }}</span
          >
        </button>
      }
    </div>

    <!-- Section Clôturés -->
    @if (closedProjects.length > 0) {
      <button
        type="button"
        class="response-projects-list-section-toggle response-projects-list-section-toggle--closed"
        (click)="toggleClosed($event)"
      >
        <span class="response-projects-list-section-badge">{{ filteredClosedProjects.length }}</span>
        <span class="response-projects-list-section-label">{{
          (filteredClosedProjects.length > 1 ? 'tenders.responses.section-closed-plural' : 'tenders.responses.section-closed') | translate
        }}</span>
        <span class="response-projects-list-section-line"></span>
        <i
          class="ph ph-caret-down response-projects-list-section-caret"
          [class.response-projects-list-section-caret--open]="effectiveClosedOpen"
          aria-hidden="true"
        ></i>
      </button>
      <div class="response-projects-list-section-body" [class.response-projects-list-section-body--open]="effectiveClosedOpen">
        @for (project of filteredClosedProjects; track project.id) {
          <button
            type="button"
            class="response-projects-list-item response-projects-list-item--closed"
            [class.response-projects-list-item-active]="project.id === activeProjectId"
            (click)="onProjectSelect(project.id)"
          >
            <i class="ph ph-check response-projects-list-item-closed-icon" aria-hidden="true"></i>
            <span
              class="response-projects-list-item-label"
              [ngbTooltip]="project.name"
              placement="right"
              tooltipClass="response-project-view-title-tooltip"
              overflowTooltip
              >{{ project.name }}</span
            >
          </button>
        }
      </div>
    }
    @if (isSearching && filteredActiveProjects.length === 0 && filteredClosedProjects.length === 0) {
      <p class="response-projects-list-no-results">{{ 'tenders.responses.search-no-results' | translate: { query: searchQuery } }}</p>
    }
  </div>

  <div class="response-projects-list-addin">
    <div class="response-projects-list-addin__header">
      <div class="response-projects-list-addin__word-icon" aria-hidden="true">W</div>
      <span class="response-projects-list-addin__title">Add-in Word</span>
    </div>
    <app-response-project-wizard-word-card [showHeader]="false" [compact]="true"></app-response-project-wizard-word-card>
  </div>
</div>
